import { BrowseKind } from '@photos/shared';
import { useLibraryState } from '../state/libraryParams';
import { BrowseView } from './BrowseView';
import { ResultsView } from './ResultsView';

export function LibraryPage() {
  const { state } = useLibraryState();
  const { tab } = state;
  return (
    <div className="wrap" id="wrap">
      {BrowseKind.safeParse(tab).success ? (
        <BrowseView key={`${tab}|${state.source}`} kind={BrowseKind.parse(tab)} />
      ) : (
        <ResultsView />
      )}
    </div>
  );
}
